import { isValidPhoneNumber } from 'react-phone-number-input';
import * as yup from 'yup';

const optionalPhone = () =>
  yup
    .string()
    .optional()
    .test(
      'valid-phone',
      'Enter a valid phone number.',
      (value) => !value || isValidPhoneNumber(value)
    );

export type CreateContactValidationSchemaOptions = {
  emailRequired?: boolean;
};

export function createContactValidationSchema(
  options: CreateContactValidationSchemaOptions = {}
) {
  const { emailRequired = true } = options;

  const primaryEmailField = emailRequired
    ? yup
        .string()
        .email('Enter a valid email.')
        .required('Please enter a primary email.')
    : yup
        .string()
        .optional()
        .test(
          'email-if-present',
          'Enter a valid email.',
          (value) => !value || yup.string().email().isValidSync(value)
        );

  return yup.object({
    first_name: yup.string().required('Please enter a first name.'),
    last_name: yup.string().required('Please enter a last name.'),
    primary_email: primaryEmailField,
    job_title: yup.string().optional(),
    phone: optionalPhone(),
    send_invitation: yup.boolean().optional(),
  });
}

export type CreateContactFormValues = yup.InferType<
  ReturnType<typeof createContactValidationSchema>
>;
